export const amenitiesDisplayed = {
  default: 10,
  desktop: 9,
  tablet: 7,
  mobile: 4,
  mobileSm: 3
}


// WEBPACK FOOTER //
// ./src/utilities/content/propertyAmenitiesDisplayed.js